import { COLORS } from "ui/variables";

import { Reservation } from "./Reservation";

export enum TableStatus {
    AVAILABLE,
    BOOKED,
    SELECTED
}

export const TABLE_STATUS_COLOR = {
    [TableStatus.AVAILABLE]: COLORS.inactive,
    [TableStatus.BOOKED]: COLORS.booked,
    [TableStatus.SELECTED]: COLORS.selected,
};

export interface Table {
    id: string,
    number: number
    reservations?: Array<Reservation>
}

export interface TableState {
    id: string,
    reservations: Array<Reservation>
    status: TableStatus,
    tableNum: number
}